var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07167 8C5.80935 6.72229 6.88601 5.67345 8.1826 4.96946C9.47919 4.26547 10.9452 3.93375 12.4186 4.01097C13.8919 4.08818 15.3152 4.57133 16.5311 5.40699C17.747 6.24266 18.7081 7.39828 19.3082 8.74611M3.23169 5.51537L3.9611 8.6749C4.08534 9.21303 4.62229 9.54856 5.16042 9.42433L8.31996 8.69492M18.9281 15.9999C18.1904 17.2776 17.1138 18.3264 15.8172 19.0304C14.5206 19.7344 13.0546 20.0661 11.5812 19.9889C10.1079 19.9117 8.68456 19.4286 7.46866 18.5929C6.25276 17.7572 5.29164 16.6016 4.69155 15.2538M20.7681 18.4845L20.0387 15.325C19.9144 14.7869 19.3775 14.4513 18.8394 14.5756L15.6798 15.305",
    stroke: "#2B3F6C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.a933b35e.svg";
export { ForwardRef as ReactComponent };